import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const InViewFadeUp = ({ children, delay = 0, style }) => {
  const { ref, inView } = useInView({
    // triggerOnce: true,
    threshold: 0.15,
  });

  return (
    <motion.div ref={ref} style={style} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }} transition={{ duration: 0.55, delay }}>
      {children}
    </motion.div>
  );
};

export default InViewFadeUp;
